import React, { useState, useContext } from "react";
import styled from "styled-components";
import {
    FlexContainer, CardHeadingLabel, CustomiseStepButton, ExplainParagraphLabel
} from "src/components";

import { SettingContext } from "../SettingContext";
import { Password, Email, AccessCode } from "../components/ChangeEmailFields";

import ChangeEmailForm from "../components/ChangeEmailForm";
import ChangePasswordForm from "../components/ChangePasswordForm";
import { UserContext } from "src/scenes/App/UserContext";
import { UserKeys } from "src/constants/userDetails";

const ChangeButton = styled(CustomiseStepButton)`
    margin: 3em 0 5px 0;
    padding: 0 !important;
`;

const ContainerGrid = styled.div`
    display: grid;
    grid-template-columns: 70% 30%;
    grid-template-rows: auto;
    column-gap: 1rem;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        grid-template-rows: auto;
        row-gap: 1rem;

        & > button {
            margin-top: -1.5rem;
            justify-self: end;
        }
    }
`;

function Security() {
    const userContext = useContext(UserContext);
    const { isAccountOwner } = useContext(SettingContext);
    const [showUserDetailsFormModal, setShowUserDetailsFormModal] = useState(false);
    const [showChangePasswordFormModal, setShowChangePasswordFormModal] = useState(false);
    
    const [securityData, setSecurityData] = useState({
        password: "********",
        email: userContext.email,
        accessCode: userContext.accessCode,
    });

    const setEmail = (param) => {
        setSecurityData({ ...securityData, email: param });

        userContext.appFns.updateUserContextProperties({ [UserKeys.EMAIL]: param });
    };

    return (
        <>
            <FlexContainer width="100%" maxWidth="48rem">
                <CardHeadingLabel>
                    Security
                </CardHeadingLabel>
                <ExplainParagraphLabel>
                    View and update your account details, profile and more.
                </ExplainParagraphLabel>
                
                <ContainerGrid>
                    <Email placeholderDisabled={true} isEditable={false} formData={securityData} inputErrors={[]}/>
                    <ChangeButton onClick={() => setShowUserDetailsFormModal(true)}>Change</ChangeButton>
                    
                    <Password placeholderDisabled={true} isEditable={false} formData={securityData} inputErrors={[]} />
                    <ChangeButton onClick={() => setShowChangePasswordFormModal(true)}>Change</ChangeButton>
                    
                    {userContext.accessCode && <AccessCode placeholderDisabled={true} isEditable={false} formData={securityData} inputErrors={[]} />}
                </ContainerGrid>
            </FlexContainer>
            {showUserDetailsFormModal && <>
                <ChangeEmailForm
                    setEmail={setEmail}
                    showDialog={showUserDetailsFormModal}
                    handleClose={setShowUserDetailsFormModal}
                    token={userContext.token}
                    isAccountOwner={isAccountOwner}
                />
            </>}

            {showChangePasswordFormModal && <>
                <ChangePasswordForm
                    showDialog={showChangePasswordFormModal}
                    handleClose={setShowChangePasswordFormModal}
                    token={userContext.token}
                    isAccountOwner={isAccountOwner}
                />
            </>}
                
        </>
    );
}

export default Security;
